import { FilterFn } from '@tanstack/react-table'

import { Select, TextField } from '@nike/eds'

export const exactStringFilter: FilterFn<any> = (row, columnId, filterValue) => {
  const rowValue = row.getValue(columnId)
  return rowValue === filterValue
}

export const includesStringFilter: FilterFn<any> = (row, columnId, filterValue) => {
  const rowValue = row.getValue(columnId)
  return Boolean(
    rowValue?.toString()?.toLowerCase()?.includes(filterValue?.toString()?.toLowerCase())
  )
}

type ColumnFiltersProps = {
  enableColumnFilters: boolean
  header: {
    column: {
      getCanFilter: () => boolean
      getFilterValue: () => string | object | undefined
      setFilterValue: (value: string | object | undefined) => void
      columnDef: {
        filterType?: 'text' | 'select' | 'dateRange'
        filterOptions?: Array<{ value: string; label: string }>
      }
    }
  }
}

export function ColumnFilters({ enableColumnFilters, header }: ColumnFiltersProps) {
  if (!enableColumnFilters || !header.column.getCanFilter()) {
    return null
  }

  const filterValue = header.column.getFilterValue() as string | { from?: string; to?: string }
  const filterType = header.column.columnDef.filterType || 'text'

  const selectOptions = [
    { value: '', label: 'All' },
    ...(header.column.columnDef.filterOptions || []),
  ]

  const dateFrom = typeof filterValue === 'object' && filterValue?.from ? filterValue.from : ''
  const dateTo = typeof filterValue === 'object' && filterValue?.to ? filterValue.to : ''

  return (
    <div>
      {filterType === 'text' && (
        <TextField
          id='table--column-filter'
          className='table--column-filter'
          type='search'
          value={typeof filterValue === 'string' ? filterValue : ''}
          onChange={(e) => header.column.setFilterValue(e.target.value || undefined)}
          label=''
          hideLabel
        />
      )}
      {filterType === 'select' && (
        <Select
          id='table--column-filter-select'
          className='table--column-filter-select'
          menuPosition='fixed'
          options={selectOptions}
          value={
            selectOptions.find((option) => option.value === filterValue) || {
              value: '',
              label: 'All',
            }
          }
          label=''
          hasErrors={false}
          errorMessage=''
          message=''
          onChange={(
            newValue: { value: string | undefined } | null
          ) => header.column.setFilterValue(newValue ? newValue.value : undefined)}
        />
      )}
      {filterType === 'dateRange' && (
        <div className="eds-flex eds-gap--8">
          <TextField
            id='table--column-filter-date-from'
            className='table--column-filter'
            type='date'
            value={dateFrom}
            onChange={e => {
              const newFrom = e.target.value;
              if (!newFrom && !dateTo) {
                header.column.setFilterValue(undefined);
              } else {
                header.column.setFilterValue({
                  from: newFrom || undefined,
                  to: dateTo || undefined,
                });
              }
            }}
            label=''
            hideLabel
            placeholder='From'
          />
          <TextField
            id='table--column-filter-date-to'
            className='table--column-filter'
            type='date'
            value={dateTo}
            onChange={e => {
              const newTo = e.target.value;
              if (!dateFrom && !newTo) {
                header.column.setFilterValue(undefined);
              } else {
                header.column.setFilterValue({
                  from: dateFrom || undefined,
                  to: newTo || undefined,
                });
              }
            }}
            label=''
            hideLabel
            placeholder='To'
          />
        </div>
      )}
    </div>
  )
}

export default ColumnFilters
